import { InitPageStrict } from "../index";

declare var App: any;
declare var storeLocation: string;
declare var refreshReplenishmentsPath: string;

class ReplenishmentAlerts {
  categories: any;
  subscription: any;
  refreshTimer: number;
  refreshing = false;
  refreshPending = false;

  constructor() {
    const _this = this;
    this.initializeChannel();
    this.categories = $("#categories");

    $(".categories-search").on("keydown", function (e) {
      if (e.key !== "Escape") return;
      $(this).val("");
      _this.filterCategories("");
    });

    $(".categories-search").on("input", function (e) {
      _this.filterCategories($(this).val() as string);
    });

    this.setupCartonPopovers();

    document.addEventListener("visibilitychange", () => {
      if (!document.hidden && this.refreshPending && !this.refreshing) this.scheduleRefresh();
    });

    window.setInterval(() => this.scheduleRefresh(), 5 * 60 * 1000);
  }

  setupCartonPopovers() {
    const closeAll = () => {
      $(".carton-popover").prop("hidden", true);
      $(".carton-summary-pill").attr("aria-expanded", "false");
    };

    const position = ($pill: any, $popover: any) => {
      const rect = $pill[0].getBoundingClientRect();
      const width = $popover.outerWidth();
      const height = $popover.outerHeight();
      const margin = 8;

      let left = rect.right - width;
      if (left < margin) left = margin;
      if (left + width > window.innerWidth - margin) left = window.innerWidth - margin - width;

      let top = rect.bottom + 4;
      if (top + height > window.innerHeight - margin) top = rect.top - height - 4;
      if (top < margin) top = margin;

      $popover.css({ position: "fixed", top: `${top}px`, left: `${left}px`, right: "auto" });
    };

    $(document).on("click.cartonpop", ".carton-summary-pill", function (e) {
      e.stopPropagation();
      const $pill = $(this);
      const $popover = $pill.siblings(".carton-popover");
      const willOpen = $popover.prop("hidden");
      closeAll();
      if (willOpen) {
        $popover.prop("hidden", false);
        position($pill, $popover);
        $pill.attr("aria-expanded", "true");
      }
    });

    $(document).on("click.cartonpop", ".carton-popover", (e) => e.stopPropagation());
    $(document).on("click.cartonpop", closeAll);
    $(document).on("keydown.cartonpop", (e) => {
      if (e.key === "Escape") closeAll();
    });
    $(window).on("scroll.cartonpop resize.cartonpop", closeAll);
    $(".table-responsive").on("scroll.cartonpop", closeAll);
  }

  initializeChannel() {
    this.subscription = App.cable.subscriptions.create(
      {
        channel: "Alerts::ReplenishmentUpdatesChannel",
        tenant_code: storeLocation
      },
      {
        received: () => this.scheduleRefresh()
      }
    );
  }

  scheduleRefresh() {
    if (this.refreshTimer) return;
    this.refreshTimer = window.setTimeout(() => {
      this.refreshTimer = null;
      this.refreshTable();
    }, 2000);
  }

  refreshTable() {
    if (this.refreshing || document.hidden) {
      this.refreshPending = true;
      return;
    }
    this.refreshing = true;
    this.refreshPending = false;
    const checkedIds = $("input[name='handheld[]']:checked").map((_, el) => $(el).data('id')).get();

    $.ajax({
      url: `${refreshReplenishmentsPath}${window.location.search || ""}`,
      method: "GET",
      dataType: "html",
      success: (response: string) => {
        const html = $('<div>').append($.parseHTML(response));

        // Replace table and update checkboxes
        const newTable = html.find(".replenishment_table");
        $(".replenishment_table").replaceWith(newTable);

        checkedIds.forEach(id => {
          $(`input[name='handheld[]'][value='${id}']`).prop('checked', true);
        });

        const totalCheckboxes = $("input[name='handheld[]']").length;
        const checkedCheckboxes = $("input[name='handheld[]']:checked").length;
        $("#selectAll").prop("checked", checkedCheckboxes === totalCheckboxes);

        // Replace pagination
        const newPagination = html.find(".pagination-container");
        $(".pagination-container").replaceWith(newPagination);

        // Replace counter
        const newCounter = html.find(".sn-counter");
        $(".sn-counter").replaceWith(newCounter);

        // Replace last update
        const newLastUpdate = html.find(".last-update");
        $(".last-update").replaceWith(newLastUpdate);

        $('[data-toggle="tooltip"]').tooltip();
      },
      error: () => {
        console.error("Error fetching real-time replenishment data.");
      },
      complete: () => {
        this.refreshing = false;
        if (this.refreshPending && !document.hidden) this.scheduleRefresh();
      }
    });
  }

  filterCategories(searchTerm: string) {
    const _this = this;
    const term = searchTerm.toLowerCase().trim();

    if (term === "") {
      this.categories.find(".category-child").hide();
      this.categories.find(".category-item:not(.category-child)").show();
      this.categories
        .find(".fa-caret-down")
        .removeClass("fa-caret-down")
        .addClass("fa-caret-right");
      return;
    }

    this.categories
      .find(".category-item")
      .hide()
      .find(".fa-caret-down")
      .removeClass("fa-caret-down")
      .addClass("fa-caret-right");

    this.categories.find(".category-item").each(function () {
      const $li = $(this);
      const categoryName = $li.find("span").text().toLowerCase();

      if (categoryName.includes(term)) _this.showCategory($li);
    });
  }

  showCategory($item: any) {
    $item
      .show()
      .find(".fa-caret-right")
      .removeClass("fa-caret-right")
      .addClass("fa-caret-down");

    const match = $item.attr("class").match(/category-parent-(\d+)/);
    if (match) {
      var parentId = match[1];
      const $parent = $(`.category-item[data-category-id="${parentId}"]`);
      this.showCategory($parent);
    }
  }
}

export function LoadPage() {
  InitPageStrict("alerts replenishment", () => { new ReplenishmentAlerts(); })
}
